module.exports = __webpack_public_path__ + "015ccf94827e1cea90414118fa13a7a9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 500
// module chunks = 5